<script setup lang="ts">
import LoadingButton from "@/components/LoadingButton.vue"
import Pdf from "@/components/Pdf.vue"
import VarsityContentProcessor from "@/components/VarsityContentProcessor.vue"
import { defineTranslations } from "@/utils/defineTranslations"
import { sleep, useHttpClient, useLoadingState } from "@/vf"
import { ref } from "vue"

const props = defineProps<{
    accountId: string
}>()

const emit = defineEmits<(e: "done") => void>()
const http = useHttpClient()

const loading = useLoadingState()
const success = ref(false)

async function submit() {
    loading.while(async () => {
        await http.post(`/person-action/${props.accountId}/submit-prepared-documents`)

        success.value = true

        await sleep(2000)

        emit("done")
    })
}

const trans = defineTranslations({
    description: {
        de: "Soll das Mitglied jetzt zur Prüfung eingereicht werden?",
        en: "Should the member be submitted for review now?",
    },
    submit: {
        de: "Zur Prüfung einreichen",
        en: "Submit for review",
    },
    success: {
        de: "Die Dokumente wurden zur Prüfung eingereicht.",
        en: "The documents have been submitted for review.",
    },
})
</script>

<template>
    <div v-if="success" class="my-5 py-5 text-center">
        <div class="mb-5">
            <i class="fa fa-fw fa-check-circle fa-5x text-success"></i>
        </div>
        <VarsityContentProcessor :content="trans('success')"></VarsityContentProcessor>
    </div>
    <div v-else>
        <div class="row">
            <div class="col-md-7">
                <Pdf :file="`/person-action/${props.accountId}/framework-agreement-in-preparation`"></Pdf>
            </div>
            <div class="col-md-5">
                <div class="text-center">
                    <div class="mb-3">
                        {{ trans("description") }}
                    </div>
                    <div class="d-flex justify-content-center">
                        <LoadingButton @click="submit()" :loading="loading.state">
                            {{ trans("submit") }}
                        </LoadingButton>
                    </div>
                    <slot name="afterSubmit"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
